import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Type from "./Type";

function Contact() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Support
              </h1>
              <p style={{ paddingBottom: 15 }}>
If you have any questions or suggestions about our apps, please contact us at <b>mehmetalicelebii@gmail.com</b>
              </p>
            </Col>

            
          </Row>
        </Container>
      </Container>
    </section>
  );
}

export default Contact;
